import { render, staticRenderFns } from "./EditarTraslado.vue?vue&type=template&id=796e750e&scoped=true"
import script from "./EditarTraslado.vue?vue&type=script&lang=js"
export * from "./EditarTraslado.vue?vue&type=script&lang=js"
import style0 from "./EditarTraslado.vue?vue&type=style&index=0&id=796e750e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796e750e",
  null
  
)

export default component.exports